// extracted by mini-css-extract-plugin
export default {"buyerContainer":"_h0itCTwBmipva3pPgy0__buyerContainer___","multiLine":"HZH2TiOto3zGu1iyf1dB__multiLine___","categoriesContainer":"iyk89XzK0CPxG0HfirAl__categoriesContainer___"};